import React from 'react'
import PricingTable from '.'
import Section from '../Div'
import Spacing from '../Spacing'

export default function PricingTableList() {
  return (
    <Section className="position-relative">
      <Section className="row">
        <Section className="col-lg-4">
          <PricingTable 
            title='The Starter'
            price='1490'
            currency='$'
            timeline='monthly'
            features={[' 4 Long-Form Videos (5–12 min)', '4 Reels/Shorts repurposed from main content', 'Stock Footage + Licensed Music', 'Light Motion Graphics', 'Clean Color Correction & Audio Polish', 'Light Creative Direction', '2 Rounds of Revisions']}
            btnText='Make Me Consistent'
            btnLink='/'
          />
          <Spacing lg='25' md='25'/>
        </Section>
        <Section className="col-lg-4">
          <PricingTable 
            title='The Builder'
            price='2290'
            currency='$'
            timeline='monthly'
            features={['5 Long-Form Videos (or 5 + more Reels, based on strategy)', '6 Custom Shorts/Reels (Designed separately for max retention)', ' Monthly Content Strategy Session (Hooks, topics, formats)', 'Enhanced Motion Graphics & Transitions', 'Thumbnail Direction + SEO Suggestions', ' 3 Rounds of Revisions']}
            btnText='Plan My Growth'
            btnLink='/'
          />
          <Spacing lg='25' md='25'/>
        </Section>
        <Section className="col-lg-4">
          <PricingTable 
            title='The Brand'
            price='2990'
            currency='$'
            timeline='monthly'
            features={['Branded Video System (Custom transitions, fonts, layouts)', ' Brand Identity Support (Typography, color palette, logo animation)', ' Kinetic Typography & Advanced Text Animations', 'Personalized Content Templates (for repeatable formats)', ' Audience-Psychology Edits', ' Scripting Assistance (hooks, CTA integration, intros)', ' Priority Turnaround + Private WhatsApp Support', ' Brand Evolution Support (Ongoing visual refinement & strategy)']}
            btnText='Craft My Signature Content'
            btnLink='/'
          />
          <Spacing lg='25' md='25'/>
        </Section>
      </Section>
    </Section>
  )
}